import { ElementType } from '@editor2/types/pageElements';

export const QUESTION_TYPES = [
	ElementType.MCQuestion,
	ElementType.MCQuestionPool,
	ElementType.SAQuestion,
	ElementType.YourTurn,
	ElementType.Poll,
	ElementType.PollResults
];
